import {
  BlueskyRecommendationKey,
  RecommendationTaskType,
} from '../../utils/enums'
import metadata from '../metadata/bluesky.yaml'
import { parseMetadataRegistry } from '../recommendationMetadataParsing'
import { parseSpec } from '../recommendationSpecParsing'
import { Recommendation } from '../recommendationTypes'
import { RecommendationRegistryApi } from '../registryTypes'
import specs from '../specs/bluesky.yaml'

const BLUESKY_RECOMMENDATION_KEYS = [
  BlueskyRecommendationKey.BLUESKY_2FA,
  BlueskyRecommendationKey.BLUESKY_DELETE_POSTS_BEFORE,
  BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION,
  BlueskyRecommendationKey.BLUESKY_MESSAGES,
  BlueskyRecommendationKey.BLUESKY_MODERATION,
  BlueskyRecommendationKey.BLUESKY_FEEDS,
  BlueskyRecommendationKey.BLUESKY_POST_INTERACTIONS,
]

const BLUESKY_RECOMMENDATIONS_REGISTRY: Record<
  BlueskyRecommendationKey,
  Recommendation
> = {
  [BlueskyRecommendationKey.BLUESKY_2FA]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_2FA]),
    key: BlueskyRecommendationKey.BLUESKY_2FA,
  },
  [BlueskyRecommendationKey.BLUESKY_DELETE_POSTS_BEFORE]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_DELETE_POSTS_BEFORE]),
    key: BlueskyRecommendationKey.BLUESKY_DELETE_POSTS_BEFORE,
  },
  [BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION]),
    hasAutomatedGather: true,
    key: BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION,
  },
  [BlueskyRecommendationKey.BLUESKY_MESSAGES]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_MESSAGES]),
    key: BlueskyRecommendationKey.BLUESKY_MESSAGES,
  },
  [BlueskyRecommendationKey.BLUESKY_MODERATION]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_MODERATION]),
    key: BlueskyRecommendationKey.BLUESKY_MODERATION,
  },
  [BlueskyRecommendationKey.BLUESKY_FEEDS]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_FEEDS]),
    key: BlueskyRecommendationKey.BLUESKY_FEEDS,
  },
  [BlueskyRecommendationKey.BLUESKY_POST_INTERACTIONS]: {
    ...parseSpec(specs[BlueskyRecommendationKey.BLUESKY_POST_INTERACTIONS]),
    key: BlueskyRecommendationKey.BLUESKY_POST_INTERACTIONS,
  },
}

export const blueskyRegistry: RecommendationRegistryApi = {
  getRecommendationKeys: () => BLUESKY_RECOMMENDATION_KEYS,
  getSetupRecommendationKeys: () => BLUESKY_RECOMMENDATION_KEYS,
  getChecklistKeys: () =>
    BLUESKY_RECOMMENDATION_KEYS.filter(
      (key) => !BLUESKY_RECOMMENDATIONS_REGISTRY[key].taskType,
    ),
  getContentTaskKeys: () =>
    BLUESKY_RECOMMENDATION_KEYS.filter(
      (key) =>
        BLUESKY_RECOMMENDATIONS_REGISTRY[key].taskType ===
        RecommendationTaskType.CONTENT,
    ),
  getExperienceTaskKeys: () =>
    BLUESKY_RECOMMENDATION_KEYS.filter(
      (key) =>
        BLUESKY_RECOMMENDATIONS_REGISTRY[key].taskType ===
        RecommendationTaskType.EXPERIENCE,
    ),
  getRecommendationsRegistry: () => BLUESKY_RECOMMENDATIONS_REGISTRY,
  getRecommendationsMetadataRegistry: () => parseMetadataRegistry(metadata),
}
